<template>
<div>




        <!-- Catalogos Cliente -->
        <v-menu v-if="view_trafico==1 &&  menu_catalogos" bottom nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :title="fullWidth < 1024?'Catálogos':''" :icon="fullWidth <= 1024">
                    <v-icon>list</v-icon>
                    <span class="caption">Catálogos</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('catalogos.embarques') && view_costing==0 " to="/catalogos/emisores_destinatarios" @click.shift="openNew('/catalogos/emisores_destinatarios');">

                    <v-icon>mdi-circle-small</v-icon>Emisores/Destinatarios

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.emisores') && view_costing==0 " to="/catalogos/embarcadores" @click.shift="openNew('/catalogos/embarcadores');">

                    <v-icon>mdi-circle-small</v-icon>Embarcadores/Consignatarios

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.transportistas') && view_costing==0 " to="/catalogos/transportistas" @click.shift="openNew('/catalogos/transportistas');">

                    <v-icon>mdi-circle-small</v-icon>Transportistas

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.agentes.aduanales') && view_costing==0  " to="/catalogos/agentes" @click.shift="openNew('/catalogos/agentes');">

                    <v-icon>mdi-circle-small</v-icon>Agentes Aduanales

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.agentes') && view_costing==1 " to="/catalogos/agentescarga" @click.shift="openNew('/catalogos/agentescarga');">

                    <v-icon>mdi-circle-small</v-icon>Proveedores Logísticos

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.representantes')" to="/catalogos/representantes" @click.shift="openNew('/catalogos/representantes');">

                    <v-icon>mdi-circle-small</v-icon>Representantes Legales

                </app-bar-item>

                <!--app-bar-item v-if="valida_permiso('catalogos.bancos') && view_trafico==1" to="/apendices/bancos" @click.shift="openNew('/apendices/bancos');">

                    <v-icon>mdi-circle-small</v-icon>Bancos

                </app-bar-item-->

                <app-bar-item v-if="valida_permiso('catalogos.mercancias') && view_trafico==1" to="/catalogos/mercancias" @click.shift="openNew('/catalogos/mercancias');">

                    <v-icon>mdi-circle-small</v-icon>Mercancía/Producto

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('Reportes.personalizados.referencias') && this.$local_storage.get('tipo_usuario') == 'Super Usuario' && view_trafico==0 && view_costing==0" to="/catalogos/referencias" @click.shift="openNew('/catalogos/referencias');">

                    <v-icon>mdi-circle-small</v-icon>Planta-Referencia

                </app-bar-item>

            </v-list>
        </v-menu>

      

        <!-- Utilerias -->
        <v-menu v-if="view_trafico==1 &&  menu_utilerias" nav bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Utilerias':''" v-tippy>
                    <v-icon>dashboard</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Utilerías</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('administracion.usuarios')" to="/catalogos/usuarios" @click.shift="openNew('/catalogos/usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.aduanas') && !soloEcosting" to="/clientes/aduanas" @click.shift="openNew('/clientes/aduanas');">

                    <v-icon>mdi-circle-small</v-icon>Aduanas Cliente

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.apendices') && !soloEcosting" to="/apendices/24" @click.shift="openNew('/apendices/24');">

                    <v-icon>mdi-circle-small</v-icon>Apéndices

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.logistica.estados') && view_trafico==1" to="/configurar_estados" @click.shift="openNew('/configurar_estados');">

                    <v-icon>mdi-circle-small</v-icon>Configurar Estados de Tráfico

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administeacion.logistica.columnas') && view_trafico==1" to="/configurar_columnas" @click.shift="openNew('/configurar_columnas');">

                    <v-icon>mdi-circle-small</v-icon>Configurar Columnas de Tráfico

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.logistica.plantillas') && view_trafico==1" to="/catalogos/templates" @click.shift="openNew('/catalogos/templates');">

                    <v-icon>mdi-circle-small</v-icon>Templates

                </app-bar-item>





                <!--    <app-bar-item v-if="valida_permiso('administracion.log')" to="/catalogos/logsistemausuario" @click.shift="openNew('/catalogos/logsistemausuario');">

                    <v-icon>mdi-circle-small</v-icon>Log del Sistema

                </app-bar-item> -->

                <app-bar-item v-if="valida_permiso('administracion.accesos')" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Log de Accesos

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('administracion.enotes')" to="/catalogos/enotes" @click.shift="openNew('/catalogos/enotes');">

                    <v-icon>mdi-circle-small</v-icon>eNotes

                </app-bar-item>

               
            </v-list>
        </v-menu>

        <!-- Logistica -->
        <v-menu v-if="menu_logistica && view_trafico==1 " bottom fixed nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text :icon="fullWidth <= 1024" v-on="on" :title="fullWidth <= 1024?'Logística':''" v-tippy>
                    <v-icon>local_shipping</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Logística</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('Logistica.nuevoregistro')" @click.native="redirectNuevoTrafico(1)" @click.shift="redirectNuevoTrafico(2)">

                    <v-icon>mdi-circle-small</v-icon>Nuevo Registro

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('Logistica.verregistro')" to="/trafico_index" @click.shift="openNew('/trafico_index');">

                    <v-icon>mdi-circle-small</v-icon>Ver Registro Tráfico

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('eDrive.carga.zip') && view_trafico==1" to="/cargar_adjuntos_trafico" @click.shift="openNew('/cargar_adjuntos_trafico');">

                    <v-icon>mdi-circle-small</v-icon>Carga Adjuntos Tráfico

                </app-bar-item>

            </v-list>
        </v-menu>

        <!-- Administracion Logistica -->
        <v-menu v-if="menu_admin_logistica && view_trafico==1 " bottom nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon>list</v-icon>
                    <span class="caption">Administración</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('Administracion.Logistica.garantias')" to="/traficos/solicitud_devolucion_garantia" @click.shift="openNew('/traficos/solicitud_devolucion_garantia');">

                    <v-icon>mdi-circle-small</v-icon>Garantías

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('Administracion.Logistica.cuentaaduanera')" to="/traficos/solicitud_cuenta_aduanera" @click.shift="openNew('/traficos/solicitud_cuenta_aduanera');">

                    <v-icon>mdi-circle-small</v-icon>Cuenta Aduanera

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('Administracion.Logistica.cuentagastos')" to="/traficos/solicitud_pago_garantia" @click.shift="openNew('/traficos/solicitud_pago_garantia');">

                    <v-icon>mdi-circle-small</v-icon>Cuenta de Gastos

                </app-bar-item>
            </v-list>
        </v-menu>

     

      

        <!-- Edrive  Gestion Embarques-->
        <v-menu v-if="menu_logistica_edrive  && view_trafico==1 " bottom offset-y origin="center center" nav transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                    <v-icon>account_tree</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">E-Drive</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('Logistica.facturas.transito.cargar')" to="/cargar_facturastransito" @click.shift="openNew('/cargar_facturastransito');">
                    <v-icon>mdi-circle-small</v-icon>Cargar Facturas en Tránsito
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('Logistica.facturas.transito.consultar')" to="/facturastransito" @click.shift="openNew('/facturastransito');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Facturas en Tránsito
                </app-bar-item>
                <v-divider />
                <app-bar-item v-if="valida_permiso('Logistica.ordenes.abiertas.cargar')" to="/ecosting/referencia-pedimento" @click.shift="openNew('/ecosting/referencia-pedimento');">
                    <v-icon>mdi-circle-small</v-icon>Cargar Referencia Pedimento
                </app-bar-item>
                <!--app-bar-item v-if="valida_permiso('Logistica.ordenes.abiertas.cargar')" to="/ordenesabiertascargar" @click.shift="openNew('/ordenesabiertascargar');">
                    <v-icon>mdi-circle-small</v-icon>Cargar Ordenes Abiertas
                </app-bar-item-->
                <app-bar-item v-if="valida_permiso('Logistica.ordenes.abiertas.consultar')" to="/ordenesabiertas" @click.shift="openNew('/ordenesabiertas');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Ordenes Abiertas
                </app-bar-item>

            </v-list>
        </v-menu>

      
        <!-- Reportes -->
        <v-menu v-if="view_trafico==1" bottom offset-y origin="center center" nav transition="scale-transition" >
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                    <v-icon>file_copy</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso('Reportes.Logistica.reporte.facturas') && view_trafico==1 && view_costing==0" to="/reportes/facturas" @click.shift="openNew('/reportes/facturas');">

                    <v-icon>mdi-circle-small</v-icon>Reporte de Facturas

                </app-bar-item>
               
                <app-bar-item v-if="valida_permiso('Reportes.Logistica.reporte.facturas') && view_trafico==0 && view_costing==1" to="/pedimento_uuid" @click.shift="openNew('/pedimento_uuid');">

                    <v-icon>mdi-circle-small</v-icon>Reporte Pedimento - UUID

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('Reportes.logistica.reporte.trafico') && view_trafico==1 && view_costing==0" to="/trafico_reportes" @click.shift="openNew('/trafico_reportes');">

                    <v-icon>mdi-circle-small</v-icon>Reporte de Tráfico

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('Logistica.reporte.consignatarios') && view_trafico==1 && view_costing==0" to="/trafico/reporte_embarques" @click.shift="openNew('/trafico/reporte_embarques');">

                    <v-icon>mdi-circle-small</v-icon>Reporte Consignatarios

                </app-bar-item>
                <v-divider v-if="is_cliente" />
                <app-bar-item v-if="!Admin" to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                    <v-icon>mdi-circle-small</v-icon>Manual de Usuario
                </app-bar-item>
               
                <app-bar-item v-if="!Admin" to="/videotutorial" @click.shift="openNew('/videotutorial');">

                    <v-icon>mdi-circle-small</v-icon>Video Tutoriales

                </app-bar-item>

            </v-list>
        </v-menu>

      
</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";


export default {
    name: "menuTrafico",


    created() {


    },
    components: {
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100  &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100 || this.$local_storage.get("EmanifiestoMV.Logistica.bitacora") == 100) ;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1 ;
        },
        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo"); ;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos");
        },
        soloCartaPorte(){
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
        menu_catalogos() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("catalogos.emisores") ||
                    this.valida_permiso("catalogos.embarques") ||
                    this.valida_permiso("catalogos.transportistas") ||
                    this.valida_permiso("catalogos.agentes") ||
                    this.valida_permiso("catalogos.representantes") ||
                    this.valida_permiso("catalogos.agentes") ||
                    this.valida_permiso("catalogos.bancos") ||
                    this.valida_permiso("catalogos.mercancias")
                ) && this.view_emanifiesto == 0 && this.view_carta_porte == 0
            );
        },
        menu_utilerias() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("administracion.usuarios") ||
                    this.valida_permiso("administracion.aduanas") ||
                    this.valida_permiso("administracion.apendices") ||
                    this.valida_permiso("administracion.logistica.estados") ||
                    this.valida_permiso("administeacion.logistica.columnas") ||
                    this.valida_permiso("administracion.logistica.plantillas") ||
                    this.valida_permiso("administracion.log") ||
                    this.valida_permiso("administracion.accesos") ||
                    this.valida_permiso("administracion.enotes") ||
                    this.valida_permiso("administracion.indicadores") ||
                    this.valida_permiso("Anexo24.reportes") ||
                    this.valida_permiso("administracion.configurables")

                ) && this.view_emanifiesto == 0 && this.view_carta_porte == 0
            );
        },
       
        menu_logistica_edrive() {
            return ( //false &&
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("Logistica.facturas.transito.cargar") ||
                    this.valida_permiso("Logistica.ordenes.abiertas.consultar") ||
                    this.valida_permiso("Logistica.ordenes.abiertas.cargar") ||
                    this.valida_permiso("Logistica.facturas.transito.consultar")
                )
            );

        },
        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },
       
        menu_logistica() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("Logistica.nuevoregistro") ||
                    this.valida_permiso("Logistica.verregistro")

                )
            );
        },
        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
        menu_admin_logistica() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("Administracion.Logistica.garantias") ||
                    this.valida_permiso("Administracion.Logistica.cuentaaduanera") ||
                    this.valida_permiso("Administracion.Logistica.cuentagastos")

                )
            );
        },
       
        esGrupo(){
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
       
        openNew: function (h) {
            window.open(h, "_blank");
        },
         redirectNuevoTrafico: function (opcion) {
            this.$local_storage.set("referencia", "");
            this.$local_storage.set("update", false);
            if (opcion == 1) {
                this.$root.$emit("forceRerender", "force"); //Forzamos el re-render del componente
                this.$router.push("/nuevo_trafico").catch(() => {});
            } else window.open("/nuevo_trafico", "_blank");
        },
     
    },
    
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
